/**
 * @generated SignedSource<<71d367b519874ad9a422660af67ab032>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorListFragment_facility$data = {
  readonly department: {
    readonly instructorProfiles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly staffProfile: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_staffProfile">;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_facility">;
  readonly " $fragmentType": "InstructorListFragment_facility";
};
export type InstructorListFragment_facility$key = {
  readonly " $data"?: InstructorListFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorListFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorListFragment_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorCardFragment_facility"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Department",
      "kind": "LinkedField",
      "name": "department",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "active",
              "value": true
            }
          ],
          "concreteType": "InstructorDepartmentProfileConnection",
          "kind": "LinkedField",
          "name": "instructorProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InstructorDepartmentProfileEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "InstructorDepartmentProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StaffProfile",
                      "kind": "LinkedField",
                      "name": "staffProfile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "InstructorCardFragment_staffProfile"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "instructorProfiles(active:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "b7ef48c233b2bfd266d3c227ec899828";

export default node;
